import React from 'react';
import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const HighSchoolFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={(theme) => ({
        mt: 'auto',
        color: '#F4F7FC',
        backgroundColor: theme.palette.mode === 'dark' ? '#080E1B' : '#101B31',
        borderTop: `1px solid ${theme.palette.mode === 'dark' ? '#26324D' : '#243550'}`,
      })}
    >
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 5 } }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1.4fr 1fr 1fr' }, gap: { xs: 3, md: 6 } }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: 0.2, mb: 1 }}>
              A3 High School
            </Typography>
            <Typography variant="body2" sx={{ maxWidth: 420, color: '#C3CDDC', lineHeight: 1.75 }}>
              Exam preparation, practical learning, and school tools to help students learn and prepare with confidence.
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1.5, color: '#FFFFFF', letterSpacing: 0.4 }}>
              Learning
            </Typography>
            <Stack spacing={1}>
              <Link component={RouterLink} to="/high-school/about" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>About A3 High School</Link>
              <Link component={RouterLink} to="/waec" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>WAEC Topics</Link>
              <Link component={RouterLink} to="/jamb" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>JAMB Topics</Link>
              <Link component={RouterLink} to="/labs" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>Practical Labs</Link>
            </Stack>
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1.5, color: '#FFFFFF', letterSpacing: 0.4 }}>
              Student & Family
            </Typography>
            <Stack spacing={1}>
              <Link component={RouterLink} to="/school-work" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>School Work</Link>
              <Link component={RouterLink} to="/mock-test/jamb" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>JAMB Mock Test</Link>
              <Link component={RouterLink} to="/mock-test/waec" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>WAEC Mock Test</Link>
              <Link component={RouterLink} to="/high-school/contact" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>Student Support</Link>
              <Link component={RouterLink} to="/parent/login" underline="hover" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>Parent / Guardian Login</Link>
            </Stack>
          </Box>
        </Box>
        <Divider sx={{ my: 3, borderColor: '#34445D' }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="caption" sx={{ color: '#AAB7CA' }}>
            © {currentYear} A3 High School. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2.5}>
            <Link component={RouterLink} to="/privacy" underline="hover" variant="caption" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>Privacy</Link>
            <Link component={RouterLink} to="/terms" underline="hover" variant="caption" sx={{ color: '#C3CDDC', '&:hover': { color: '#7FE0D5' } }}>Terms</Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default HighSchoolFooter;
